import { render, staticRenderFns } from "./TheNavbarVertical.vue?vue&type=template&id=701bccaf&scoped=true"
import script from "./TheNavbarVertical.vue?vue&type=script&lang=js"
export * from "./TheNavbarVertical.vue?vue&type=script&lang=js"
import style0 from "./TheNavbarVertical.vue?vue&type=style&index=0&id=701bccaf&prod&lang=scss"
import style1 from "./TheNavbarVertical.vue?vue&type=style&index=1&id=701bccaf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "701bccaf",
  null
  
)

export default component.exports